import { useContext, useMemo } from 'react';

import { LoggerContext } from './logger-provider';

export function useLogger(context?: string) {
  const loggerContext = useContext(LoggerContext);

  if (!loggerContext) {
    throw new Error('useLogger must be used within a LoggerProvider');
  }

  return useMemo(() => {
    if (context) {
      return loggerContext.logger.withContext(context);
    }
    return loggerContext.logger;
  }, [loggerContext, context]);
}
